import { useState, useEffect } from "react";

import './TechnicalAssistance.css';

import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import PageTopic from "components/PageTopic";
import { Svg_Delete, Svg_Edit } from "components/Svg";

import { SetListPag } from "interface/Page";
import { SetModalData, SetModalState } from "interface/PopUp";
import { GetDataPage, RegisterDataPage, UnRegisterDataPage } from "interface/Data";

import { colorIcon } from "fixedData";

export default function Page_Administrator_TechnicalAssistance(props){

    const [ search, setSearch ] = useState('');
    const [ currentData, setCurrentData ] = useState(GetDataPage('technical_assistance'));
    const [ listData, setListData ] = useState(GetDataPage('technical_assistance'));

    const [ itensPage, setItensPage ] = useState(50);
    const [ showPage, setShowPage ] = useState(0);

    const page = Math.ceil(listData.length / itensPage);
    const startItens = showPage * itensPage;
    const endItens = startItens + itensPage;
    const currentItens = listData.slice(startItens, endItens);

    function SearchInput(value){
        const newList = [];
        if(value){
            GetDataPage('technical_assistance').forEach(item =>{
                if(item.status == 1){
                    if(item.name.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.state.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.city.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.address.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.complement.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.email.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.responsable.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                    if(item.phone.toLowerCase().indexOf(value.toLowerCase()) != -1){
                        newList.push(item);
                    }
                }
            });
            const duplicate = newList.filter((item, index) => newList.indexOf(item) === index);
            setListData(duplicate);
        }else {
            setListData(GetDataPage('technical_assistance'));
        }
        setSearch(value);
    }

    function PageClick(idPage){
        SetListPag('currentPage', 'technical_assistance_details');
        SetListPag('currentPageId', idPage);
    }

    function DeleteData(id, value){
        SetModalData('Confirmation', { "id": id, "origin": "technical_assistance", "type": "delete_data", "status": 0, "name": value });
        SetModalState('Confirmation', true);
    }

    useEffect(()=>{
        RegisterDataPage('technical_assistance', setCurrentData);
        return ()=>{
            UnRegisterDataPage('technical_assistance', setCurrentData);
        };
    }, []);

    useEffect(()=>{
        setCurrentData(GetDataPage('technical_assistance'));        
        setListData(GetDataPage('technical_assistance'));
    }, [currentData]);

    return(
        <div className="width_page">
            <PageTopic type="block" PageClick={ PageClick } SearchInput={ SearchInput } titlePage="Assistência técnica" historic={ [] } />

            <div className="list_project">
                <table cellPadding="0" cellSpacing="0">
                    <thead>
                        <tr>
                            <th width="20" align="center">#</th>
                            <th>Nome</th>
                            <th width="200">Estado</th>
                            <th width="200">Cidade</th>
                            <th width="80">Contato</th>
                            <th width="60" align="right">#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            currentItens.length > 0 ?
                            currentItens.map((elem, index)=>{
                                return(
                                    <tr key={ index }>
                                        <td align="center">{ startItens + index + 1 }</td>
                                        <td>{ elem.name }</td>
                                        <td>{ elem.state }</td>
                                        <td>{ elem.city }</td>
                                        <td>{ elem.phone }</td>
                                        <td align="right">
                                            <div className="list_opt">                                                
                                                <div onClick={ ()=>{ PageClick(elem.id) } } data-tooltip-id={ "id_edit_" + elem.id } data-tooltip-content="Editar assistente técnico" data-tooltip-place="top">
                                                    <Svg_Edit className="icons" color={ colorIcon } />
                                                </div>
                                                <Tooltip id={ "id_edit_" + elem.id } />
                                                
                                                <div onClick={ ()=>{ DeleteData(elem.id, elem.title) } } data-tooltip-id={ "id_delete_" + elem.id } data-tooltip-content="Deletar assistente técnico" data-tooltip-place="top">
                                                    <Svg_Delete className="icons" color="#F00000" />
                                                </div>
                                                <Tooltip id={ "id_delete_" + elem.id } />
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                            :
                            <tr>
                                <td className="no_data" align="center" colSpan={ 6 }>Nenhum cadastro encontrado...</td>
                            </tr>
                        }
                    </tbody>
                </table>
                {
                    listData.length >= 50 ?
                    <div className="list_pages">
                        {
                            Array.from(Array(page), (item, index)=>{
                                return(
                                    <div className={ showPage == index ? "numb_page" : "numb_page page_active" } key={ index } onClick={ (e)=>{ setShowPage(index) } }>
                                        { index + 1 }
                                    </div>
                                )
                            })
                        }
                    </div> : null
                }
            </div>
        </div>
    )
}